import React from "react";

const TranslationContext = React.createContext({});

const TranslationProvider = TranslationContext.Provider;

export { TranslationContext };
export default TranslationProvider;
